//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomSidebarMenuItem from './CustomSidebarMenuItem.vue'
export default {
    name: 'CustomSidebarMenuItem',
    components: {
        CustomSidebarMenuItem
    },
    props: {
        items: {
            typeof: Array,
            default: null
        }
    }
}
